// extracted by mini-css-extract-plugin
export default {"policy__container":"policies_policy__container__1Cq1h"};